import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, giros_ } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const Giros = ({ id, permisos }) => {
    const [ giros, setGiros ] = useState( null );
    useEffect(() => {
        axiosGiros();
    }, []);

    const axiosGiros = () => {
        axios.get( `${servicios_grupogack_catalogo}s/giros/all`, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        setGiros( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setGiros( [] );
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    return (
        <div id={ id }>
            { giros ?
                <DataTableService id={id} title={ giros_ } permisos={permisos}
                    columns={[
                        { field: "giroNom", title: "Nombre" },
                    ]}
                    data={ giros } /> : <SpinnerOval />
            }
        </div>
    );
}
 
export default Giros;